import { motion } from "framer-motion";
import { useState, useRef, lazy, Suspense } from "react";
import Image1 from "../../../images/Website-Banner-01.webp"
import Image2 from "../../../images/Website-Banner-02.webp"
import Image3 from "../../../images/Website-Banner-03.webp"
import Image4 from "../../../images/Website-Banner-04.webp"
import Image5 from "../../../images/DSC03955.JPG"
import Carousel from "react-material-ui-carousel";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "./CTASection.css";

const AuthModal = lazy(() => import("../../VM/LoginPage/AuthModal/AuthModal"));

// Note: You might want to import a background image here
// import backgroundImage from 'path-to-your-image/background.jpg';

const BeTheChangeSection = () => {
  const theme = useTheme();

  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const [clickedFromCTA, setClickedFromCTA] = useState(false);

  const joinButtonRef = useRef(null);

  const handleJoinModalClose = () => {
    setJoinModalOpen(false);
    setClickedFromCTA(false);
  };

  // const isSmallScreen = window.innerWidth < 500;
  // const marginTop = isSmallScreen ? "-605px" : "-580px";


  return (
    // Outer container with a relative position to hold the absolute background
    <div className="joinBJS-MainContainer">
      <Carousel
        indicators={false}
        navButtonsAlwaysVisible={false}
        autoPlay={true}
        interval={3000}
        animation="slide"
        swipe
      >
        {[Image1, Image2, Image3, Image4].map((img, index) => (
          <Box
            key={index}
            sx={{
              width: "100%",
              height: {
                xs: 220,
                sm: 300,
                md: 350,
                lg: 400,   // 1200+
                xl: 500,   // 1536+
                xxl: 650,  // 1920+ if custom breakpoint exists
              },
              overflow: "hidden",
              backgroundColor: "#f9fafb",
            }}
          >
            <Box
              component="img"
              src={img}
              alt={`slide-${index}`}
              loading={index === 0 ? "eager" : "lazy"}
              decoding="async"
              fetchPriority={index === 0 ? "high" : "auto"}
              sx={{
                width: "100%",
                height: "100%",
                display: "block",

                // IMPORTANT
                objectFit: "cover",

                // Optional:
                objectPosition: "center",
              }}
            />
          </Box>
        ))}
      </Carousel>

      <motion.div
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="joinBJSCard"
        style={{ backgroundColor: theme.palette.primary.main }}
      // style={{ backgroundColor:"transparent" }}
      >
        <div className="d-flex flex-col sm:flex-col items-center justify-between gap-1">
          {/* Text Content */}
          <span style={{ textAlign: "center", color: theme.palette.secondary.main }}>
            {/* <h2
                className="font-extrabold leading-tight mb-0"
              >
                Volunteer Management System (VMS)
              </h2> */}
            <Typography variant="h3" sx={{ marginBottom: "8px", fontSize:{xs:"18px", sm:"22px", md:"22px", lg:"26px"} }}>Connecting Volunteers. Strengthening Chapters. Accelerating Impact.</Typography>
          </span>
          {/* The placeholder 'Lorem Ipsum' text is used here */}
          <p className="text-sm md:text-base text-gray-50 max-w-4xl text-center justify-center " style={{ lineHeight: 1.4, fontSize: "0.92rem", marginBottom: 0 }}>
            {/* For over four decades, Bharatiya Jain Sanghatana (BJS) has been a beacon of selfless service, 
              dedicated to the Jain community and the larger cause of nation-building through thousands of committed volunteers. 
              BJS has never confined itself to a single cause or field. Whether it's being the first to 
              reach out in disaster relief, rehabilitating orphaned children, protecting the nation from the grip of drought, 
              instilling values in education to build a stronger society, or preserving the sanctity of family systems,
              BJS has always stood where humanity needed it most. Wherever there is need, BJS stands as a symbol of trust, 
              compassion, and unwavering commitment. Ready to serve, ready to rebuild, and ready to inspire hope. */}
            {/* Ai Shortened Description */}
            A unified digital platform empowering BJS’s 500+ chapters with seamless coordination, structured communication, and smarter volunteer collaboration, driving community development with greater efficiency and scale.
          </p>

          {/* Button - Aligned to the right/center as in the image */}
          {/* <motion.button
            ref={joinButtonRef}
            onClick={handleJoinModalOpen}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 0 15px rgba(255, 255, 255, 0.6)",
            }}
            whileTap={{ scale: 0.9 }}
            className={`flex-shrink-0 bg-white font-bold text-lg 
                       px-6 py-3 rounded-full shadow-xl transition-all duration-300 
                       hover:bg-gray-100 whitespace-nowrap`}
            style={{ color: theme.palette.primary.main, marginTop: "0px" }}
          >
            Join BJS
          </motion.button> */}
        </div>
      </motion.div>
      <Suspense fallback={null}>
        <AuthModal
          open={joinModalOpen}
          onClose={handleJoinModalClose}
          anchorRef={joinButtonRef}
          clickedFromCTA={clickedFromCTA}
        />
      </Suspense>
    </div >
  );
};

export default BeTheChangeSection;
